import { TableCell } from '@mui/material';
import React from 'react';
import styles from './styles';

export enum SortDirection {
    Ascending,
    Descending,
}

interface SortHeaderProps {
    name: string;
    label: string;
    direction?: SortDirection;
    sortVisible?: boolean;
    onSort: (name: string, sortDirecton: SortDirection) => void;
}

const getIcon = (direction?: SortDirection): JSX.Element | string => {
    if (direction == null) {
        return <></>;
    }

    switch (direction) {
        case SortDirection.Ascending:
            return <img src="../images/up-arrow.svg" alt="" />;
        case SortDirection.Descending:
            return <img src="../images/down-arrow.svg" alt="" />;
        default:
            return <img src="../images/down-arrow.svg" alt="" />;
    }
};

const getSortDirection = (currentSort?: SortDirection): SortDirection => {
    return currentSort == null || currentSort === SortDirection.Descending
        ? SortDirection.Ascending
        : SortDirection.Descending;
};

const SortableHeader: React.FC<SortHeaderProps> = ({ name, label, direction, onSort, sortVisible = true }): any => {
    return (
        <TableCell
            id={name}
            component="th"
            scope="row"
            sx={styles.headerLabel}
            key={label}
            onClick={() => {
                if (sortVisible) onSort(name, getSortDirection(direction));
            }}
        >
            <span style={styles.sortText}>
                {label} {sortVisible && getIcon(direction)}
            </span>
        </TableCell>
    );
};

export default SortableHeader;
